import React, { useCallback } from 'react';
import { useLocation } from 'react-router-dom';
import _ from 'lodash';

import Typography from '../../common/typography/Typography';
import MainLogo from '../../common/icon/MainLogo';
import { StyledFooter, CompanyInfoDiv2, SnsContainer, RightContainer, TermsDiv2 } from '../../../styles/LayoutStyles';
import SelectLanguage from '../SelectLanguage';

import { HOMEPAGE_URL, SNS_URL } from '../../../constants';
import { COMMON } from '../../../constants/regexp';

import useLanguagePack from '../../../hooks/useLanguagePack';
import useUser from '../../../store/user';

const Footer = () => {
  const location = useLocation();

  const { user } = useUser(
    useCallback(state => ({
      user: state.user,
    }))
  );

  const languageKeyStrings = {
    infoText: useLanguagePack('landing_fnb_info_1'),
    textButton1: useLanguagePack('landing_fnb_textlink_1'),
    textButton2: useLanguagePack('landing_fnb_textlink_2'),
    textButton3: useLanguagePack('landing_fnb_textlink_3'),
    textButton4: useLanguagePack('landing_fnb_textlink_4'),
    textButton5: useLanguagePack('landing_fnb_textlink_5'),
    textButton6: useLanguagePack('landing_fnb_textlink_6'),
    textButton7: useLanguagePack('helpcenter721_tab_4'),
  };
  return (
    <StyledFooter>
      <CompanyInfoDiv2>
        <div onClick={() => window.open(HOMEPAGE_URL, '_blank', 'noreferrer')} style={{ cursor: 'pointer' }}>
          <MainLogo />
        </div>
        <SnsContainer>
          {SNS_URL.map(i => (
            <li key={i.name}>
              <a href={i.url} target='_blank' rel='noopener noreferrer'>
                <img src={i.image} alt={i?.name} />
              </a>
            </li>
          ))}
        </SnsContainer>
        {languageKeyStrings.infoText && (
          <Typography
            variant={'C4'}
            color={'gray2'}
            dangerouslySetInnerHTML={{
              __html: languageKeyStrings.infoText?.replace(
                COMMON['SQUARE_BRACKET'],
                `<span onclick="window.open('https://www.ftc.go.kr/bizCommPop.do?wrkr_no=7128700690', '_blank')" tabindex="0" style="cursor:pointer;">${
                  languageKeyStrings.infoText?.split(COMMON['SQUARE_BRACKET'])[languageKeyStrings.infoText.split.length - 1]
                }</span>`
              ),
            }}
          />
        )}
      </CompanyInfoDiv2>
      <RightContainer>
        <TermsDiv2>
          <Typography
            variant={'C3'}
            role={'button'}
            tabIndex={0}
            onClick={() => window.open(`${process.env.REACT_APP_URL}/help`, '_blank')}
          >
            {languageKeyStrings.textButton4}
          </Typography>
          <Typography
            variant={'C3'}
            role={'button'}
            tabIndex={0}
            onClick={() => window.open(`${process.env.REACT_APP_URL}/guide`, '_blank')}
          >
            {languageKeyStrings.textButton7}
          </Typography>
          <Typography variant={'C3'} role={'button'} tabIndex={0} onClick={() => window.open(`${process.env.REACT_APP_URL}/faq`, '_blank')}>
            {languageKeyStrings.textButton5}
          </Typography>
          <Typography
            variant={'C3'}
            role={'button'}
            tabIndex={0}
            onClick={() => window.open(`${process.env.REACT_APP_URL}/notice`, '_blank')}
          >
            {languageKeyStrings.textButton6}
          </Typography>
        </TermsDiv2>
        <TermsDiv2>
          <Typography
            variant={'C3'}
            role={'button'}
            tabIndex={0}
            onClick={() => window.open(`${process.env.REACT_APP_URL}/terms/service`, '_blank')}
          >
            {languageKeyStrings.textButton1}
          </Typography>
          <Typography
            variant={'C3'}
            role={'button'}
            tabIndex={0}
            onClick={() => window.open(`${process.env.REACT_APP_URL}/terms/license`, '_blank')}
          >
            {languageKeyStrings.textButton2}
          </Typography>
          <Typography
            className={'highlighted'}
            variant={'C3'}
            role={'button'}
            tabIndex={0}
            onClick={() => window.open(`${process.env.REACT_APP_URL}/terms/privacy`, '_blank')}
          >
            {languageKeyStrings.textButton3}
          </Typography>
        </TermsDiv2>
        {(!_.isEmpty(user) || /\/(help|notice|faq)/.test(location.pathname)) && (
          <div>
            <SelectLanguage />
          </div>
        )}
      </RightContainer>
    </StyledFooter>
  );
};

export default Footer;
